import React from 'react';
import Overview from './Overview';
import ConversationQuality from './ConversationQuality';
import ConversationsByService from './ConversationsByService'
import ConversationsPerDay from './ConversationsPerDay'
import MessagesByType from './MessagesByType'
import MessagesByLanguage from './MessagesByLanguage';
import MessagesPerDay from './MessagesPerDay';
import TrainStationsOverview from './TrainStationsOverview'
import KPIDashboard from './KPIDashboard';
import DashboardWrapper from 'components/wrappers/DashboardWrapper';
import AnalyticsExportBar from './AnalyticsExportBar';

function Analytics() {
    return (
        <DashboardWrapper>
            <AnalyticsExportBar />
            <div className="grid grid-cols-12 gap-6">
                <Overview />
                <ConversationQuality />
                <ConversationsPerDay />
                <ConversationsByService />

                <MessagesPerDay />
                <TrainStationsOverview />
                <MessagesByType />
                <MessagesByLanguage />

                <KPIDashboard />
            </div>
        </DashboardWrapper>
    );
}

export default Analytics;


